import { render } from "./SignupPopup.vue?vue&type=template&id=04c3e1cc&scoped=true"
import script from "./SignupPopup.vue?vue&type=script&lang=js"
export * from "./SignupPopup.vue?vue&type=script&lang=js"

import "./SignupPopup.vue?vue&type=style&index=0&id=04c3e1cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c3e1cc"]])

export default __exports__